<template>
  <div id="app" v-cloak>
    <loading v-show="LOADING" />
    <transition name="transitionName" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import loading from "./views/loading"
import { mapState } from 'vuex'
export default {
  name: 'App',
  components: { loading },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      LOADING: function (state) {
        return state.loading.LOADING
      },
    })
  },
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("initVuex")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("initVuex"))
        )
      );
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("initVuex", JSON.stringify(this.$store.state));
    });

  }
}
</script>

<style lang="scss">
@import "./assets/style/index.scss";

[v-cloak] {
  display: none;
}

#app {
  background: $colorBg;
  min-height: 100vh;
  // overflow-x: hidden;
}

.transitionName-enter-active,
.transitionName-leave-active {
  transition: opacity 0.2s;
}

.transitionName-enter,
.transitionName-leave-active {
  opacity: 0;
}

.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all .2s;
}

// .transitionName-enter,
// .transitionName-leave-active {
//   opacity: 0;
//   transform: translateX(20px);
// }

// .transitionName-move {
//   transition: all .5s;
// }

// .transitionName-leave-active {
//   position: absolute;
// }

</style>
